import React from 'react';
import T from 'prop-types';
import { TextArea } from '@acast/decibel';
import Field from 'shared/components/field';
import { convertPropNameToCssSelector } from 'routes/show/util';

const ShowTextAreaField = ({
  onChange,
  meta,
  propName,
  label,
  placeholder,
  help,
  value,
  subtitle,
  disabled,
  renderToggleDisabled,
  maxlength,
}) => (
  <Field
    name={convertPropNameToCssSelector(propName)}
    label={label}
    meta={meta}
    help={help}
    subtitle={subtitle}
    disabled={disabled}
    renderToggleDisabled={renderToggleDisabled}
    isRequired
  >
    <TextArea
      placeholder={placeholder}
      onChange={event => onChange(event.target.value)}
      value={value}
      maxlength={maxlength}
      invalid={typeof meta.error === 'string'}
    />
  </Field>
);

ShowTextAreaField.propTypes = {
  onChange: T.func,
  meta: T.object,
  propName: T.string,
  label: T.string,
  placeholder: T.string,
  help: T.string,
  subtitle: T.string,
  disabled: T.bool,
  renderToggleDisabled: T.func,
  value: T.any,
  maxlength: T.number,
};

export default ShowTextAreaField;
